/** Matches backend geo JSON (`code` field). */
export const GEO_RESTRICTION_RESPONSE_CODE = "SERVICE_UNAVAILABLE_REGION";

export const DEFAULT_GEO_RESTRICTION_MESSAGE =
  "BetBond is only available in Rwanda. If you believe this is a mistake, contact support.";

export function isGeoRestrictionResponse(status, data) {
  return status === 403 && data?.code === GEO_RESTRICTION_RESPONSE_CODE;
}

export function formatLicensedRegions(regions) {
  const list = Array.isArray(regions) ? regions.filter(Boolean) : [];
  if (!list.length) return "Rwanda";
  const names = { RW: "Rwanda" };
  return list.map((code) => names[code] || code).join(", ");
}
